<template>
  <div>
    <IdmSubHeader>
      <span class="logo-link">
        <IdmLogo :app="'scene creator'" />
      </span>

      <h1 class="title" v-if="scene">{{ scene.display_name }}</h1>

      <branding @preview="$emit('preview')" />

      <sceneInfo :scene="scene" :duration="duration" />

      <IdmButton
        class="header"
        :btnType="'header'"
        :text="'Clear changes'"
        :disabled="!scene || !scene.edited"
        @click="clearAllChanges"
        data-test="topbar-clear-changes-button"
      ></IdmButton>

      <sceneSave
        class="scene-save"
        :scene="scene"
        :video="video"
        :video-url="videoUrl"
        :gif-url="gifUrl"
        :library-id="libraryId"
      />
    </IdmSubHeader>
  </div>
</template>

<script>
import { useBuilderStore } from "@/stores/builderStore";
import branding from '@/views/editor/topbar/branding.vue';
import sceneInfo from '@/views/editor/topbar/sceneInfo.vue';
import sceneSave from '@/views/editor/topbar/sceneSave.vue';

export default {
  name: 'topbar',

  components: {
    branding,
    sceneInfo,
    sceneSave,
  },

  props: ['scene', 'video', 'videoUrl', 'gifUrl', 'libraryId', 'duration'],

  computed: {
    builderStore() {
      return useBuilderStore();
    },
    scene() {
      return this.builderStore.scene;
    },
    selectedNode() {
      return this.builderStore.selectedNode;
    },
  },

  methods: {
    closeScene() {
      this.$emit('close');
    },
    clearAllChanges() {
      this.builderStore.undoAllNodeChanges();
      if(this.selectedNode) {
        const node = this.scene.nodes.find(n => n.key === this.selectedNode.key);
        this.builderStore.selectNode(node);
      }
      this.$emit("preview", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.idm-subheader .logo-link {
  position: relative;
}

.idm-btn.header.header {
  margin-left: 24px;
}

.scene-save {
  margin-left: 8px;
}

.idm-logo {
  pointer-events: none;
}
</style>
